import PayPalLogoWithText from "@/assets/images/billing/payment-method-icons/pp-text.svg";
import {Button} from "@/components/button/Button.tsx";
import {useCheckoutContext} from "@/components/context/hooks.ts";
import {PaymentMethodType} from "@/lib/types/billing.ts";
import {CostBreakdown, CostBreakdownProps} from "@/pages/billing/v2/summary/CostBreakdown.tsx";

export interface CostBreakdownWithPaymentProps extends Omit<CostBreakdownProps, "children"> {
  paymentType?: PaymentMethodType;
  formId?: string;
  disabled?: boolean;
}

/*
 * Plain CostBreakdown can be used as an alternative if direct access to button is required.
 */
export const CostBreakdownWithPayment = ({paymentType, formId, ...props}: CostBreakdownWithPaymentProps) => {
  const {requestInProgress} = useCheckoutContext();
  return (
    <>
      <CostBreakdown {...props}>
        <>
          <Button
            type={"submit"}
            form={formId}
            className="w-100"
            size="large"
            variant={paymentType === PaymentMethodType.PAYPAL && !requestInProgress ? "paypal" : "primary"}
            disabled={requestInProgress}
          >
            {requestInProgress ? (
              "Working..."
            ) : paymentType === PaymentMethodType.PAYPAL ? (
              <img src={PayPalLogoWithText} style={{height: "24px"}} />
            ) : (
              "Complete Checkout"
            )}
          </Button>
        </>
      </CostBreakdown>
    </>
  );
};
